export default __webpack_public_path__ + "static/media/Filter2.0c168598.svg";